import { render, staticRenderFns } from "./ClientFileEditor.vue?vue&type=template&id=6e39e6b4&scoped=true&"
import script from "./ClientFileEditor.vue?vue&type=script&lang=js&"
export * from "./ClientFileEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClientFileEditor.vue?vue&type=style&index=0&id=6e39e6b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39e6b4",
  null
  
)

export default component.exports